"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.compareString = function (main, searchString) {
  return main.toLowerCase().indexOf(searchString.toLowerCase()) > -1;
};

exports.toFilterArray = function (filters) {
  return Object.entries(filters).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return {
      name: k,
      value: v
    };
  });
}; // above is generalization of
// const filterArray:FilterUnit<Animal>[] = Object.entries(filters).map(([k, v]) => ({name: k as keyof Animal, value: v as FilterSearchValue}))


exports.compare = function (main, search //| Search,
) {
  var mainType = typeof main;
  var searchType = typeof search;

  if (searchType === 'string') {
    // here casting the `main` so that it can match with the search even if not of the same type
    switch (mainType) {
      case 'string':
        return exports.compareString(main, search);

      case 'number':
        return main === Number(search);

      default:
        return false;
    }
  }

  return false;
}; // this is a hack that will work for nested objects... leaving like this until better option


exports.searchInObject = function (searchString, object) {
  return JSON.stringify(object).toLowerCase().includes(searchString.toLowerCase());
}; // same as above but only works with linear object, the rsult will be more precise though


exports.searchInObjectLinear = function (searchString, object) {
  return Object.keys(object).map(function (o) {
    var main = object[o];
    return exports.compare(main, searchString);
  }).reduce(function (a, b) {
    return a || b;
  });
}; // todo here unfortunately `k` cant be typed as keyof A, typescript bug/limitation?


exports.applyFilter = function (data, filterArray) {
  //filters: {[k : string]:any}): A[] => {
  //const filterArray:{name: string, value: any}[] = Object.entries(filters).map(([name, value]:[string,any]) => ({name, value}))
  if (filterArray.length === 0) {
    return data;
  } //console.log(filterArray)


  return data.filter(function (d) {
    return filterArray.map(function (f) {
      if (f.name === 'globalSearch' && typeof f.value === 'string') {
        return exports.searchInObject(f.value, d);
      }

      if (f.name !== 'globalSearch') {
        var key = f.name;

        if (typeof f.value === 'object') {
          if (typeof f.value.func === 'function' && f.value.value) {
            if (Array.isArray(f.value.value) && f.value.value.length > 0) {
              return f.value.func(d, f.value.value);
            } else {
              //console.log('h')
              //console.log(f.value.value)
              return f.value.func(d, f.value.value.value);
            }
          }

          return true;
        }

        return exports.compare(d[key], f.value);
      }

      return true;
    }).reduce(function (a, b) {
      return a && b;
    });
  });
};

exports.addRemoveToArray = function (v) {
  var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!a) {
    return [v];
  }

  if (a.includes(v)) {
    var idx = a.indexOf(v);
    a.splice(idx, 1);
    return a;
  }

  a.push(v);
  return a;
};

exports.updateFilters = function (filters, v) {
  if (v.value === null || v.value === '') {
    delete filters[v.name];
  } else {
    // if object
    if (typeof v.value !== 'string') {
      if (v.type === 'category') {
        if (!filters[v.name]) {
          filters[v.name] = {
            value: [],
            func: v.value.func
          };
        }

        filters[v.name].value = exports.addRemoveToArray(v.value.value, filters[v.name].value);

        if (filters[v.name].value.length === 0) {
          delete filters[v.name];
        }
      } else {
        if (!filters[v.name]) {
          filters[v.name] = {
            value: null,
            func: v.value.func
          };
        }

        filters[v.name].value = v.value;
      }
    } else {
      // if string
      filters[v.name] = v.value;
    }
  } // setState({ ...state, filters, pageIdx });


  return filters;
};